module.exports = __webpack_public_path__ + "static/media/banner5.bc154066.jpg";